import api from '../../common/api';
import util from '../../share/util/utils';
import handler from '../../share/util/apiResultValidator';
import config from '../../share/config';
import resource from '../../share/util/resourceMap';
import apiService from "../../share/util/api/service";
import authority from '../../share/util/authorityCheck';
import { DIAG } from '../../constants/usageCountTypes';
const publishedUnitListTestMode = require('../../data/testMode/publishedUnits.json');
const pfcFileListTestMode = require('../../data/testMode/pfcFileList.json');

function buildTestModeTable(suFlow) {
  // Random select programmable status
  const publishedUnitListTestModeTemp = JSON.parse(JSON.stringify(publishedUnitListTestMode));
  for (let index = 0; index < publishedUnitListTestModeTemp.length; ++index) {
    if (Math.random() < 0.5) {
      publishedUnitListTestModeTemp[index].reprogrammable_info.normal.reprogrammable_status = config.SYSTEM_STATUS_NOT_REPROGRAMMABLE;
      publishedUnitListTestModeTemp[index].pfc_file_id = null;
    } else {
      // テストモード用に、pfcファイルリストに照合用のリプロ有のidデータを作成する
      pfcFileListTestMode.pfcFileIdList.push({
        "id": publishedUnitListTestModeTemp[index].id,
        "pfc_file_id": "1234-5678-90",
        "type": "normal"
      });
    }
    // Special handling for RCR to display target unit information
    if (publishedUnitListTestModeTemp[index].system_names.length > 1 &&
      publishedUnitListTestModeTemp[index].system_names[0].system_name === 'RCR_L') {
      const targetRomId = publishedUnitListTestModeTemp[index].target_romid;
      publishedUnitListTestModeTemp[index].target_romid = `LH：${targetRomId.slice(0, -1)}0  RH：${targetRomId.slice(0, -1)}2`;
    }
  }

  const publishResult = resource.getVehicleSystemStatus(publishedUnitListTestModeTemp, suFlow);
  for (let index = 0; index < publishResult.vehicleSystemList.length; ++index) {
    publishResult.vehicleSystemList[index].name = publishedUnitListTestModeTemp[index].name;
    publishResult.vehicleSystemList[index].fieldSpec.isCommunicatable = config.LIST_ITEM_DISABLE;
    publishResult.vehicleSystemList[index].fieldSpec.isInstallation = config.LIST_ITEM_DISABLE;
  }

  return {
    published: util.sortItems(publishedUnitListTestModeTemp, 'id', config.ASC),
    unpublished: []
  };
}

export default {
  data() {
    return {

    };
  },
  namespaced: true,

  state: {
    // リプロ機能向けシステム一覧テーブル情報
    systemTable: null,
    // リプロ機能テーブルでのダイアログ表示制御用フラグ
    showSystemTblModal: true,
    // 診断情報一覧データ
    allDtcSystems: null,
    // リプロサポート対象有無フラグ
    isReproSupport: false,
    // カスタム情報一覧取得
    customizeSystems: null,
    // ページネーション管理
    runPaginateData: false,
    // 商品コードテーブル
    merchandiseTable: null,
  },

  mutations: {
    setNativeSystemTable(state, payload) {
      state.systemTable = payload;

      let isSupport = false;
      //リプロ情報を表示するための判断
      //SSM5車でpublishedかunpublishedにデータが存在する場合stateをtrueに更新する
      //既販車であればstateをfalseに更新する
      if (payload) {
        const isSoldVehicleFlg = payload.isSoldVehicleFlg ? true : false;
        if (!isSoldVehicleFlg) {
          if (payload && payload.unpublished && payload.unpublished.length !== 0) {
            isSupport = true;
          }
          if (payload && payload.published && payload.published.length !== 0) {
            isSupport = true;
          }
        }
      }
      state.isReproSupport = isSupport;
    },
    setSystemTblModalFlag(state, payload) {
      state.showSystemTblModal = payload;
    },
    setAllDtcTable(state, payload) {
      state.allDtcSystems = payload;
    },
    setRunPaginateData(state, payload) {
      state.runPaginateData = payload;
    },
    merchandiseCodeTbl(state, payload) {
      state.merchandiseTable = payload;
    },

    /**
     * 個別システムの DTC 情報を更新する
     * @param {object} state State
     * @param {string} payload.system 更新対象のシステム
     * @param {object} payload.data 更新対象のシステムの全データ
     */
    setIndividualDtcData(state, payload) {
      // ALL DTCのstateが存在しない場合、return
      if (!state.allDtcSystems) {
        return;
      }

      // 現在の state を全コピー
      const currentAllDtcSystems = Object.assign({}, state.allDtcSystems);

      // 上書き予定のシステムの先頭indexを取得する
      const targetFirstIndex = currentAllDtcSystems.data.findIndex(dtc => dtc.system === payload.system);

      // 全ダイアグコード取得⇒個別診断のダイアグコード取得の際、
      // 後ろに個別診断のダイアグコード結果を結合すると、全ダイアグコードに戻った際に順番が入れ替わってしまう。
      // これを避けるため、 対象システムのデータをクリアし、削除した位置に要素に挿入している。
      currentAllDtcSystems.data = currentAllDtcSystems.data.filter(dtc => dtc.system !== payload.system);
      // 先頭のindexが存在する場合、その位置にデータを結合する
      if (targetFirstIndex !== -1) {
        payload.data.forEach((dtc, index) => {
          currentAllDtcSystems.data.splice(targetFirstIndex + index, 0, dtc);
        });
      } else {
        // 該当のindexが存在しない場合、配列の後ろに結合する
        currentAllDtcSystems.data = currentAllDtcSystems.data.concat(payload.data);
      }

      // state を更新
      state.allDtcSystems = currentAllDtcSystems;
    },

    setCustomizeTable(state, payload) {
      state.customizeSystems = payload;
    },
  },

  actions: {
    // DTCテーブル一覧情報を取得
    async getDtcSystemTable(context, arg) {
      // Response結果をオブジェクトに入れる
      const getDtcResponse = {
        errorResult: null
      };
      if (arg.projectId && arg.measureId) {
        const endPoint = '/diagDtc/' + arg.projectId + '/' + arg.measureId;
        const res = await api.getCall(config.DIAG, endPoint, arg.operationScreen);
        handler.validate(
          handler.validateTypes.all,
          res, null, null,
          () => {
            if (!res.data.clear_dtc_all_system_count && res.data.clear_dtc_all_system_count !== 0) {
              // clear_dtc_all_system_countが無かった場合
              res.data.clear_dtc_all_system_count = -1;
            }
            // 処理が成功したときデータを入れる
            context.commit('setAllDtcTable', res.data);
          },
          (result) => {
            // 処理が失敗してる場合
            getDtcResponse.errorResult = result;
          }, null, false);
        return getDtcResponse;
      }
      // measureIdが取れ無かった場合、エラーにはせず空配列で返す
      else {
        context.commit('setAllDtcTable', { clear_dtc_all_system_count: -1, data: [] });
        return getDtcResponse;
      }

    },
    // リプロ対象に応じた商品コードの詳細を取得する
    async merchandiseCodeTbl(context, arg) {
      // Published/UnPublishedのレスポンスから、商品コードを重複無しの状態で取り出す
      const unitListToMerchandiseCodes = function (unitList) {
        const merchandiseCodeSet = new Set();
        for (const unitInfo of unitList) {
          // テストモードのときは商品コードのリストが存在しないので空配列に置き換える
          const merchandiseCodeList = unitInfo.merchandise_code_list ?? [];
          for (const merchandiseCode of merchandiseCodeList) {
            merchandiseCodeSet.add(merchandiseCode);
          }
        }
        return merchandiseCodeSet;
      };
      const publishedMerchandiseCodes = unitListToMerchandiseCodes(arg.published);
      const unPublishedMerchandiseCodes = unitListToMerchandiseCodes(arg.unpublished);

      // Published/UnPublishedの商品コードを重複無しの状態にする
      const uniqueMerchandiseCodes = new Set();
      for (const merchandiseCodes of [publishedMerchandiseCodes, unPublishedMerchandiseCodes]) {
        for (const merchandiseCode of merchandiseCodes) {
          uniqueMerchandiseCodes.add(merchandiseCode);
        }
      }

      const merchandiseCodeDetails = {};
      for (const merchandiseCode of uniqueMerchandiseCodes) {
        // 各商品コードの詳細情報を取得する
        const merchandiseCodeDetail = await apiService.getCall(apiService.REPRO, '/merchandise/' + merchandiseCode);
        merchandiseCodeDetails[merchandiseCode] = merchandiseCodeDetail;
      }

      // 公開/非公開それぞれでアップデートプログラム一覧に表示する内容を設定する
      const publishedMerchandiseList = Array.from(publishedMerchandiseCodes).map(merchandiseCode => merchandiseCodeDetails[merchandiseCode]);
      const unPublishedMerchandiseList = Array.from(unPublishedMerchandiseCodes).map(merchandiseCode => merchandiseCodeDetails[merchandiseCode]);
      const merchandiseDetails = {
        pub: publishedMerchandiseList,
        unpub: unPublishedMerchandiseList,
      };
      context.commit('merchandiseCodeTbl', merchandiseDetails);
      return { isValid: true, data: null };
    },

    // テーブルを取得
    async setNativeSystemTable(context, arg) {
      if (arg.mode === 'testMode') {
        const tbl = buildTestModeTable(this.suFlow);
        context.commit('setNativeSystemTable', tbl);
        return { isValid: true, data: null };
      }
      else {
        if (!arg.netAppId) {
          return { isValid: false, data: null };
        }
        const pblEndpoint = '/netApps/' + arg.netAppId + '/vehicle/units/published';
        const unpblEndpoint = '/netApps/' + arg.netAppId + '/vehicle/units/unpublished';
        let requestType = 'ssm5';
        if (arg.isSoldVehicle) {
          requestType = 'sold_vehicle';
        } else {
          if (arg.mode === 'techMode') {
            // テーブルをキャッシュ
            const tbl = {
              published: [],
              unpublished: []
            };
            context.commit('setNativeSystemTable', tbl);
            return { isValid: true, data: null };
          }
        }

        let pblTbl = [];
        let unpblTbl = [];
        let errObject = null;

        // 公開テーブル取得
        const pblRes = await api.getCall(config.REPRO, pblEndpoint + '/?request_type=' + requestType);
        const isValid = handler.validate(
          handler.validateTypes.all, pblRes, arg.obj, null, null, (result) => {
            errObject = result;
          }, null, false
        );
        if (!isValid || errObject) return { isValid: isValid, data: errObject };
        pblTbl = pblRes.data;

        // 非公開テーブル取得
        if (arg.isBothTable) {
          const unpblRes = await api.getCall(config.REPRO, unpblEndpoint + '/?request_type=' + requestType);
          const isValid = handler.validate(
            handler.validateTypes.all, unpblRes, arg.obj, null, null, (result) => {
              errObject = result;
            }, null, false
          );
          if (!isValid || errObject) return { isValid: isValid, data: errObject };
          unpblTbl = unpblRes.data;
        }
        let tbl = {};
        // 既販車の場合
        if (arg.isSoldVehicle) {
          tbl = {
            published: util.sortItems(pblTbl.pack_file_list, 'create_time', config.ASC),
            unpublished: util.sortItems(unpblTbl?.pack_file_list || [], 'create_time', config.ASC),
            countryGroups: pblTbl.country_groups,
            vehicle: pblTbl?.vehicle ?? null,
            modelYear: pblTbl?.model_year ?? null,
            model: pblTbl?.model ?? null,
            annualImprovements: pblTbl?.annual_improvements ?? null,
            lastEvaluatedKey: pblTbl?.last_evaluated_key,
            isSoldVehicleFlg: true
          };
        } else {
          tbl = {
            published: util.sortItems(pblTbl, 'id', config.ASC),
            unpublished: util.sortItems(unpblTbl, 'id', config.ASC)
          };
        }
        await context.dispatch('merchandiseCodeTbl', tbl);
        context.commit('setNativeSystemTable', tbl);
        await context.dispatch('getPaginateData', { endpoint: pblEndpoint, requestType: requestType, data: pblTbl, tableType: 'published' });
        if (arg.isBothTable) {
          await context.dispatch('getPaginateData', { endpoint: unpblEndpoint, requestType: requestType, data: unpblTbl, tableType: 'unpublished' });
        }
        return { isValid: true, data: null };
      }

    },

    async getPaginateData(context, arg) {
      let errObject = null;
      const tableType = arg.tableType || 'published';
      if (util.hasLastEvaluatedKey(arg.data)) {
        context.commit('setRunPaginateData', true);
      }
      const paginateData = context.state.systemTable[tableType];

      // ページ分割パラメータ
      // frontend からlimitは設定しない。
      const params = {
        request_type: arg.requestType,
        last_evaluated_key: JSON.stringify(arg.data.last_evaluated_key)
      };

      while (context.state.runPaginateData) {

        if (!context.state.runPaginateData) return;
        const response = await api.getParamCall(config.REPRO, arg.endpoint, params);
        if (!context.state.runPaginateData) return;

        // APIレスポンスの検証
        handler.validate(
          handler.validateTypes.all, response, null, null,
          () => {
            // 処理が成功した場合
            // paginateData にレスポンス情報を追加する。
            response.data.pack_file_list.map((data) => {
              paginateData.push(data);
            });
          },
          // レスポンス不正時のコールバック
          (result) => {
            errObject = result;
          }, null, false
        );

        if (errObject) return;
        // 次のデータが存在するかチェックする
        if (util.hasLastEvaluatedKey(response.data)) {
          params["last_evaluated_key"] = JSON.stringify(response.data.last_evaluated_key);
          context.commit('setNativeSystemTable', { ...context.state.systemTable, [tableType]: paginateData, lastEvaluatedKey: JSON.stringify(response.data.last_evaluated_key) });
        }
        else {
          // 次のデータが存在しない場合も処理終了
          context.commit('setNativeSystemTable', { ...context.state.systemTable, [tableType]: paginateData, lastEvaluatedKey: JSON.stringify(response.data.last_evaluated_key) });
          context.commit('setRunPaginateData', false);
          return;
        }
      }
    },

    // カスタマイズ一覧情報を取得
    getCustomizeSystemTable(context, arg) {
      context.commit('setCustomizeTable', arg);
    },

    setSystemTblModalFlag(context, arg) {
      context.commit('setSystemTblModalFlag', arg);
    },

    updateAllDtcDataFromIndividualDtcData(context, arg) {
      context.commit('setIndividualDtcData', arg);
    },

    // 情報を初期化
    clearTableData(context) {
      context.commit('setNativeSystemTable', null);
      context.commit('merchandiseCodeTbl', null);
      context.commit('setSystemTblModalFlag', true);
      context.commit('setAllDtcTable', null);
      context.commit('setCustomizeTable', null);
    },

    // メニュー画面遷移前処理
    async getForDisplayMenu(context, arg) {
      const userProperty = context.rootState.userProperty;
      const functionAvailability = userProperty.functionAvailability;
      const vehicleInfo = context.rootState.vehicle.vehicleInfo;
      const param = {
        netAppId: arg.pairingAppId,
        obj: arg.modal,
        isBothTable: authority.hasUnpublishedPermission(userProperty.group), 
        mode: arg.systemMode,
        isSoldVehicle: vehicleInfo.is_sold_vehicle
      };

      // リプログラミング機能が利用可能な場合、公開/非公開のユニット一覧情報を取得
      if (functionAvailability[config.EXECUE_FUNCTION_TYPE_RPR]) {
        const res = await context.dispatch('setNativeSystemTable', param);
        if (!res.isValid) {
          return { error: res.data };
        }
      }

      // Ph4 メニューを利用可能な車両のみ情報を取得する
      const canBeActivatePh4Menus = context.rootState.vehicle.vehicleInfo.vehicle?.vin?.ph4_menus_can_be_activated;
      if (canBeActivatePh4Menus) {
        // 診断機能が利用可能な場合、DTCテーブル情報を取得
        if (functionAvailability[config.EXECUE_FUNCTION_TYPE_DIAG]) {
          const projectInfo = {
            projectId: vehicleInfo.vehicle.project.id,
            measureId: vehicleInfo.vehicle.project.all_dtc.measure_id,
            operationScreen: arg.operationScreen,
          };
          const dtcTableResponse = await context.dispatch('getDtcSystemTable', projectInfo);
          if (dtcTableResponse?.errorResult) {
            // ユーザー権限エラーの場合はエラーダイアログを表示
            return { error: dtcTableResponse.errorResult };
          }
          if (arg.isFromHome) {
            //start画面からの車両情報取得では diag のカウンタだけを１加算する
            context.dispatch('observation/usageCountUp', { type: DIAG }, { root: true });
          }
        }

        // ユニット登録機能が利用可能な場合、ユニット登録メニューの表示可否のステータスを取得
        if (functionAvailability[config.EXECUE_FUNCTION_TYPE_MACKKEY]) {
          const projectMacInfo = {
            netAppId: arg.pairingAppId,
            isTestMode: context.rootState.netAppConnector.isTestMode,
          };
          const macVisibilityResponse = await context.dispatch('macKey/getMacVisibility', projectMacInfo, { root: true });
          if (macVisibilityResponse?.errorResult) {
            return { error: macVisibilityResponse.errorResult };
          }
        }

        // テストモード以外の場合のみ個別診断メニュー一覧・複数診断メニュー一覧を取得する
        if (functionAvailability[config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_DIAG]) {
          // 個別診断メニュー
          const individualMenuInfo = {
            netAppId: arg.pairingAppId,
          };
          const individualMenuData = await context.dispatch('vehicle/getIndividualMenus', individualMenuInfo, { root: true });
          if (individualMenuData?.errorResult) {
            return { error: individualMenuData.errorResult };
          }
          // 複数診断メニュー
          const multipleMenuInfo = {
            netAppId: arg.pairingAppId,
          };
          const multipleMenuData = await context.dispatch('vehicle/getMultipleMenus', multipleMenuInfo, { root: true });
          if (multipleMenuData?.errorResult) {
            return { error: multipleMenuData.errorResult };
          }
        }
        // 個車情報取得機能が利用可能な場合、各機能の利用可否情報を取得
        if (functionAvailability[config.EXECUE_FUNCTION_TYPE_REAL_WORLD_DATA]) {
          const projectRwdInfo = {
            netAppId: arg.pairingAppId,
            isTestMode: context.rootState.netAppConnector.isTestMode,
          };
          const realWorldVisibilityResponse = await context.dispatch('vehicle/getRealWorldMenus', projectRwdInfo, { root: true });
          if (realWorldVisibilityResponse?.errorResult) {
            return { error: realWorldVisibilityResponse.errorResult };
          }
        }
      }

      // イモビ登録機能が利用可能な場合、ImbMenuを取得
      if (functionAvailability[config.EXECUE_FUNCTION_TYPE_IMMOBILIZER]) {
        const projectImbInfo = {
          netAppId: arg.pairingAppId,
          isTestMode: context.rootState.netAppConnector.isTestMode,
        };
        const macMenuResponse = await context.dispatch('immobilizer/getImbMenu', projectImbInfo, { root: true });
        if (macMenuResponse?.errorResult) {
          return { error: macMenuResponse.errorResult };
        }
      }
      
      return { isValid: true, data: null };
    },
  },
};